import { render, staticRenderFns } from "./profile-box.vue?vue&type=template&id=78b9f7fe"
import script from "./profile-box.vue?vue&type=script&lang=js"
export * from "./profile-box.vue?vue&type=script&lang=js"
import style0 from "./profile-box.vue?vue&type=style&index=0&id=78b9f7fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./profile-box.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports